<!-- PC -->
<div class="absolute h-[72px] bg-secondaryCard hidden md:flex-between-center w-full left-0 top-0 md:px-10">
    <div class="flex-start-center gap-x-4">
        <a
            class="text-base text-sub-text font-normal cursor-pointer"
            [routerLink]="['/meme-dashboard']"
            routerLinkActive="!text-black font-medium"
            [routerLinkActiveOptions]="{exact: true}"
        >
            MEME Smart Buy
        </a>
        <a
            class="text-base text-sub-text font-normal cursor-pointer"
            [routerLink]="['/meme-dashboard/watchlist-marketplace']"
            routerLinkActive="!text-black font-medium"
            [routerLinkActiveOptions]="{exact: true}"
        >
            Watchlist Marketplace
        </a>
    </div>

    <div class="flex-end-center gap-x-6 w-fit">
        <button nz-button class="flex-center-center gap-x-1 !bg-gradient !h-10 !border-none !px-2" (click)="agentHubVisible = true">
            <span class="text-sm font-normal">Agent Hub</span>

            <img src="/assets/imgs/star-group.png" class="w-5" alt="" />
        </button>

        <button
            *ngIf="userService.isAuthenticated"
            nz-button
            class="!border-line gap-x-1"
            nz-dropdown
            [nzDropdownMenu]="profileMenu"
            nzTrigger="click"
            [ngClass]="{
                'pointer-events-none': !userService.isAuthenticated
            }"
        >
            <app-hexagon-img class="w-7" [imgUrl]="userService.userAvatar"></app-hexagon-img>
            <nz-avatar-group>
                <nz-avatar [nzSrc]="'/assets/imgs/chains/solana.png'" style="width: 16px; height: 16px"></nz-avatar>
                <nz-avatar [nzSrc]="'/assets/imgs/chains/base.png'" style="width: 16px; height: 16px"></nz-avatar>
                <nz-avatar [nzSrc]="'/assets/imgs/chains/bnb.png'" style="width: 16px; height: 16px"></nz-avatar>
            </nz-avatar-group>
            <span>${{(myMemeProfile?.networth || 0)| kmb2:2}}</span>
            <span nz-icon class="text-xs text-sub-text" nzType="down" nzTheme="outline"></span>
        </button>

        <button *ngIf="!userService.isAuthenticated" nz-button nzType="primary" (click)="commonService.showLogInModal()">
            <div class="colorful-text font-semibold">Connect Wallet</div>
        </button>
    </div>
</div>

<!-- Mobile -->
<div class="absolute md:hidden w-full left-0 top-0 mobile-box">
    <div class="flex-between-center gap-x-4 w-full p-4">
        <button
            *ngIf="userService.isAuthenticated"
            nz-button
            class="flex-1 !border-none gap-x-1.5 !bg-secondaryCard"
            nz-dropdown
            [nzDropdownMenu]="profileMenu"
            nzTrigger="click"
        >
            <app-hexagon-img class="w-7" [imgUrl]="userService.userAvatar"></app-hexagon-img>
            <img [src]="memeDashboardStatusService.chainImg" class="w-4 h-4" alt="" />
            <span>${{(myMemeProfile?.networth || 0)| kmb2:2}}</span>
            <span nz-icon class="text-xs text-sub-text" nzType="down" nzTheme="outline"></span>
        </button>

        <button *ngIf="!userService.isAuthenticated" nz-button nzType="primary" class="flex-1" (click)="commonService.showLogInModal()">
            <div class="colorful-text font-semibold text-sm">Connect Wallet</div>
        </button>
    </div>

    <div class="flex-start-center gap-x-2 h-10 px-4 bg-secondaryCard">
        <a
            class="text-sub-text font-normal !text-xs cursor-pointer"
            [routerLink]="['/meme-dashboard']"
            routerLinkActive="!text-black font-medium"
            [routerLinkActiveOptions]="{exact: true}"
        >
            MEME Smart Buy
        </a>
        <a
            class="text-sub-text font-normal !text-xs cursor-pointer"
            [routerLink]="['/meme-dashboard/watchlist-marketplace']"
            routerLinkActive="!text-black font-medium"
            [routerLinkActiveOptions]="{exact: true}"
        >
            Watchlist Marketplace
        </a>

        <div class="w-fit flex-end-center">
            <button nz-button class="flex-center-center gap-x-1 !bg-gradient !h-8 !border-none !px-2" (click)="agentHubVisible = true">
                <span class="text-sm font-normal">Agent Hub</span>

                <img src="/assets/imgs/star-group.png" class="w-5" alt="" />
            </button>
        </div>
    </div>
</div>

<div class="pt-[112px] md:pt-[52px]">
    <router-outlet></router-outlet>
</div>

<nz-dropdown-menu #profileMenu="nzDropdownMenu">
    <app-profile-settings-dropdown></app-profile-settings-dropdown>
</nz-dropdown-menu>

<!-- 桌面 -->
<div
    [@slideInLeftOnEnter]
    *ngIf="tradingAgentCompetitionVisible && !commonService.isMobile"
    class="fixed bottom-4 transition-all duration-300 z-10 text-[#1D3442] overflow-hidden border border-[#EAECED] shadow-md"
    [ngClass]="{
       'left-[92px]': sideBarCollapsed,
       'left-[304px]': !sideBarCollapsed,
       'w-14 h-16 rounded-lg': cardCollapsed,
       'w-[435px] h-[200px] rounded-2xl p-5': !cardCollapsed
    }"
    style="background: linear-gradient(54.35deg, #c9fffc 4.94%, #ffffff 59.48%, #ffeba3 114.02%)"
>
    <div class="relative w-full h-full">
        <!-- 折叠状态内容 -->
        <div
            class="absolute w-full h-full transition-all duration-300 cursor-pointer"
            [ngClass]="{
                'opacity-100 scale-100 pointer-events-auto z-20': cardCollapsed,
                'opacity-0 scale-95 pointer-events-none z-10': !cardCollapsed
            }"
            (click)="cardCollapsed = false"
        >
            <ng-container *ngTemplateOutlet="collapsedActivityTpl"></ng-container>
        </div>

        <!-- 展开状态内容 -->
        <div
            class="absolute w-full h-full transition-all"
            [ngClass]="{
                'opacity-0 scale-95 pointer-events-none z-10 duration-0': cardCollapsed,
                'opacity-100 scale-100 pointer-events-auto z-20 duration-300 delay-200': !cardCollapsed
            }"
        >
            <ng-container *ngTemplateOutlet="activityTpl"></ng-container>
        </div>
    </div>
</div>

<!-- 移动 -->
<ng-container *ngIf="tradingAgentCompetitionVisible && commonService.isMobile">
    <div *ngIf="!cardCollapsed" [@fadeInOnEnter] class="w-screen h-screen fixed left-0 top-0 bg-black bg-opacity-50 z-10">
        <div
            class="w-[calc(100%-32px)] h-[200px] rounded-2xl p-4 absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-to-r from-[#C9FFFC] to-[#FFEBA3] text-[#1D3442] overflow-hidden"
        >
            <div class="relative">
                <ng-container *ngTemplateOutlet="activityTpl"></ng-container>
            </div>
        </div>
    </div>

    <div
        *ngIf="cardCollapsed"
        class="fixed left-4 bottom-5 w-14 h-16 rounded-lg bg-gradient-to-r from-[#C9FFFC] to-[#FFEBA3] z-10 text-[#1D3442] overflow-hidden"
        (click)="cardCollapsed = false "
    >
        <ng-container *ngTemplateOutlet="collapsedActivityTpl"></ng-container>
    </div>
</ng-container>

<!-- 模板 -->
<ng-template #activityTpl>
    <div (click)="$event.stopPropagation()">
        <span
            nz-icon
            nzType="down"
            class="absolute top-0 right-0 text-sm cursor-pointer"
            (click)="cardCollapsed = !cardCollapsed;$event.stopPropagation()"
        ></span>

        <img src="/assets/imgs/deposit-campaign.svg" alt="meme-banner" class="absolute bottom-0 right-0 w-[90px] md:w-[112px]" />

        <div class="mt-2">
            <div class="text-sm md:text-xl font-semibold leading-[24px]">Special Deposit Giveaway</div>

            <div class="text-sm font-light mt-2 leading-[14px] pt-1">
                Win <span class="border-b-[3px] border-[#99FFF9] font-semibold text-base">USDT</span> When You Deposit to the SocialScan Agent.
            </div>

            <div class="w-9 mt-2 h-[1px] bg-black"></div>

            <div *ngIf="eventStats === 'ongoing'" class="flex-start-center mt-3">
                <span class="text-2xs mr-2.5">Ends in </span>

                <ng-container *ngFor="let timeLeftNumber of timeLeftNumbers;let last = last">
                    <div class="time-box">{{timeLeftNumber}}</div>
                    <span *ngIf="!last" class="dot-box">:</span>
                </ng-container>
            </div>
            <div
                *ngIf="eventStats === 'soon'"
                class="mt-3 relative -translate-x-[28px] pl-[28px] h-[28px] flex-start-center gap-x-1 text-[11px] bg-gradient-to-r from-[#E2FFB6A1] to-[transparent] w-[76%]"
            >
                <div class="absolute left-0 top-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white to-transparent"></div>
                <div class="absolute left-0 bottom-0 w-full h-[1px] bg-gradient-to-r from-transparent via-white to-transparent"></div>

                <span class="text-[#288B01] font-semibold">Coming Soon:</span>
                <span>11/03/2025 12:00 UTC</span>
            </div>

            <button nz-button class="mt-2.5 !rounded !h-[29px] !bg-black !bg-opacity-70" (click)="joinUs()">
                <span class="text-sm font-bold text-white">Join Now</span>
            </button>
        </div>
    </div>
</ng-template>

<!-- Collapsed 模板 -->
<ng-template #collapsedActivityTpl>
    <div class="w-full h-full flex-center-center">
        <img src="/assets/imgs/mailbox.png" class="w-8 h-8" alt="" />
    </div>
</ng-template>

<nz-modal [nzVisible]="agentHubVisible" [nzTitle]="null" (nzOnCancel)="agentHubVisible = false" [nzFooter]="null" nzCentered>
    <ng-container *nzModalContent>
        <div class="text-center text-xl font-semibold">Agent Hub</div>
        <div class="mt-3 text-sub-text mb-6 text-center w-full">Find your next 1000x MEME</div>

        <app-tg-bot-entry-card type="hunter_agent" class="block mb-4"></app-tg-bot-entry-card>

        <app-tg-bot-entry-card type="nyx_agent"></app-tg-bot-entry-card>
    </ng-container>
</nz-modal>
